package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.model.Sound
import fr.manyverse.app.domain.repository.SoundRepository

/**
 * Use case for getting sounds for a user in a specific universe.
 * Returns both default sounds and user-uploaded sounds.
 */
class GetUserSoundsUseCase(
    private val soundRepository: SoundRepository
) {
    /**
     * Gets all sounds available to a user in a universe.
     * @param universeId The universe to filter by
     * @param userId The user whose uploaded sounds to include
     * @return Result containing the list of sounds
     */
    suspend operator fun invoke(
        universeId: String,
        userId: String
    ): Result<List<Sound>> {
        return soundRepository.getSoundsByUniverseAndUser(universeId, userId)
    }
}
